import React from 'react';
import { MINI_DRAWER } from 'constants/ActionTypes';

const SidenavLogo = ({ drawerType }) => {
    const showMini = drawerType.includes(MINI_DRAWER);

    return (
        <div className="sidebar-header d-flex align-items-center">
            {showMini ? (
                <div className="mini-logo">
                    <img className="mini-logo-img" alt="..." src="assets/images/icon-meldooplus.svg" />
                    <img className="mini-logo-img-hover" alt="..." src="assets/images/logo-meldooplus.svg" width="230" />
                </div>
            ) : (
                <img alt="..." src="assets/images/logo-meldooplus.svg" width="230" />
            )}
        </div>
    );
};

export default SidenavLogo;



// WEBPACK FOOTER //
// ./components/SidenavLogo/index.js